import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { setThemeClass } from '../lib/utils'

export default function ProfilePage() {
  const [email, setEmail] = useState('')
  const [is_superuser, setIsSuperuser] = useState(false)
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'auto')
  const [message, setMessage] = useState<string | null>(null)

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/fapi/users/me')
        setEmail(data.email)
        setIsSuperuser(!!data.is_superuser)
      } catch {}
      try {
        const { data } = await api.get('/settings/me')
        if (data.theme) {
          setTheme(data.theme)
          localStorage.setItem('theme', data.theme)
          setThemeClass()
        }
      } catch {}
    })()
  }, [])

  const saveTheme = async () => {
    try {
      await api.put('/settings/me', { theme })
      localStorage.setItem('theme', theme)
      setThemeClass()
      setMessage('Préférence de thème enregistrée.')
    } catch (e: any) {
      setMessage(e?.response?.data?.detail || 'Erreur enregistrement thème')
    }
  }

  return (
    <div className="relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 -z-30 bg-gradient-to-b from-emerald-50 via-white to-white dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-900" />
      <div aria-hidden className="absolute inset-x-0 top-0 -z-40 h-[320px] bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.25),_transparent_68%)]" />

      <div className="relative mx-auto flex max-w-[1600px] flex-col gap-6 px-6 py-6">
        <section className="space-y-6 rounded-3xl border border-emerald-100/70 bg-white/90 p-8 shadow-xl shadow-emerald-500/10 dark:border-emerald-900/50 dark:bg-zinc-950/90">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-zinc-500 dark:text-zinc-400 w-24">Email:</span>
              <span className="text-zinc-900 dark:text-white">{email}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-zinc-500 dark:text-zinc-400 w-24">Admin:</span>
              <span className="text-zinc-900 dark:text-white">{is_superuser ? 'Oui' : 'Non'}</span>
            </div>
            <div className="pt-4 border-t border-zinc-200 dark:border-zinc-800">
              <label className="block text-sm font-medium mb-2 text-zinc-700 dark:text-zinc-300">Thème</label>
              <div className="flex items-center gap-2">
                <select 
                  value={theme} 
                  onChange={e=>setTheme(e.target.value)} 
                  className="flex-1 max-w-xs border border-zinc-200 dark:border-zinc-700 rounded-lg px-3 py-2 bg-transparent"
                >
                  <option value="auto">Auto</option>
                  <option value="light">Clair</option>
                  <option value="dark">Sombre</option>
                </select>
                <button 
                  onClick={saveTheme} 
                  className="rounded-full bg-emerald-500 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-emerald-500/40 transition hover:bg-emerald-600"
                >
                  Sauvegarder
                </button>
              </div>
            </div>
            {message && (
              <div className="mt-4 rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-sm text-emerald-700 dark:bg-emerald-950/40 dark:border-emerald-900/60 dark:text-emerald-200">
                {message}
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}
